export const getBillingInfoError = (billingInfo = {}) => {
  const requiredFields = [
    "nameOnInvoice",
    "email",
    "mobile",
    "addressLine1",
    "placeOfSupply",
    "pincode",
  ];

  if (requiredFields.some((field) => !String(billingInfo[field] || "").trim())) {
    return "All billing fields are required.";
  }
  if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(billingInfo.email.trim())) {
    return "Please enter a valid email address.";
  }
  if (!/^\d{10}$/.test(billingInfo.mobile.trim())) {
    return "Please enter a valid 10-digit mobile number.";
  }
  if (!/^\d{6}$/.test(billingInfo.pincode.trim())) {
    return "Please enter a valid 6-digit PIN code.";
  }
  return "";
};
